var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaryPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "url(#paint0_linear_6300_7774)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6300_7774)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1592 33.1167C21.5544 35.4238 23.962 36.7129 26.3892 36.7861C28.8214 36.8594 31.3053 35.707 33.8507 33.1313C33.4814 33.0459 33.0875 32.9629 32.6715 32.8799V32.8823L32.6124 32.8701C31.8838 32.7261 30.552 32.46 29.7125 31.9546C29.235 31.6665 28.9642 31.3857 28.9716 31C28.3414 31.3735 27.6792 31.6128 26.9997 31.708C25.9633 31.8545 24.8999 31.6616 23.8561 31.0977C23.9078 31.5298 23.6666 31.8325 23.2038 32.1108C22.485 32.543 21.3304 32.731 20.4861 32.8677C20.2891 32.8994 20.1094 32.9287 19.9371 32.9629C19.6663 33.0093 19.4078 33.0605 19.1592 33.1167ZM22.3693 17.3428C23.9964 20.1602 27.1351 22.0425 32.9669 22.2573C33.1368 22.748 33.0826 23.2632 32.9669 23.7808C30.5741 31.8862 24.4445 34.1738 20.2079 25.9048L19.5728 24.2153C18.2754 21.5859 20.6928 22.6577 21.5766 20.7949L21.9483 19.1763L22.3693 17.3428ZM33.8507 25.3311C36.081 16.7422 33.8703 13.1094 29.8061 12.4233C28.942 11.4858 27.3321 11.061 26.1947 11C16.3725 11.4932 15.9245 21.8716 18.3838 28.7075L20.7962 28.1802C21.5077 29.2007 22.256 29.9893 23.0216 30.5605L23.0462 30.5996C23.2973 31.0098 23.1472 31.2881 22.8197 31.4834C22.2265 31.8423 21.1507 32.0156 20.363 32.1426C20.1389 32.1792 19.9346 32.2109 19.7918 32.2402C17.212 32.7407 15.5257 33.3364 14.4598 34.584C13.3988 35.8267 13 37.665 13 40.6362C13 40.8389 13.1649 41 13.3668 41H39.6332C39.8375 41 40 40.8364 40 40.6362C40 37.5845 39.579 35.7485 38.4491 34.5156C37.3241 33.2876 35.5443 32.7114 32.8118 32.167V32.1646L32.7527 32.1523C32.0659 32.0156 30.8104 31.7666 30.0867 31.332C29.7175 31.1099 29.5082 30.8315 29.7051 30.4897C29.9218 30.3188 30.1335 30.1309 30.3403 29.9258C31.4111 28.8711 32.3515 27.3721 33.0777 25.502L33.8507 25.3311ZM34.828 33.3804C31.9798 36.3955 29.1611 37.7407 26.3646 37.6577C23.5681 37.5747 20.8356 36.061 18.1597 33.3608C16.7221 33.7563 15.7054 34.2593 15.0235 35.0552C14.1299 36.1001 13.7681 37.6968 13.7385 40.27H39.264C39.2319 37.6309 38.8553 36.0391 37.9076 35.0039C37.2257 34.2568 36.2237 33.7759 34.828 33.3804Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6300_7774",
    x1: -4.02331e-7,
    y1: 27,
    x2: 54,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01757D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6300_7774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 30,
    fill: "white",
    transform: "translate(13 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaryPolicy);
export default __webpack_public_path__ + "static/media/Mary-Policy.0a083596799bfb6b12ef812cfb52eae6.svg";
export { ForwardRef as ReactComponent };